export const listContractsGridColumns = [
  // {
  //   "name": "acoes",
  //   "title": "Ações",
  //   width: '80px',
  // },
  {
    title: 'Ações',
    type: 'checkboxProtocoloEnvio',
    name: 'checked',
    width: '50px'
  },
  {
    "name": "Contrato",
    "title": "Contrato",
    width: '60px'
  },
  {
    "name": "CPFCNPJ",
    "title": "CPF ou CNPJ do Cliente",
    width: '120px'
  },
  {
    "name": "NomeCliente",
    "title": "Nome do Cliente",
    width: '80px'
  },
  {
    "name": "carteira",
    "title": "Carteira",
    width: '80px'
  },
  {
    "name": "Loja",
    "title": "Loja",
    width: '80px'
  },
  {
    "name": "database",
    "title": "Data Base",
    width: '60px'
  },
  {
    "name": "statusRecepcao",
    "title": "Status Recepção",
    width: '80px'
  },
  {
    "name": "DataProtocoloF",
    "title": "Data do Protocolo",
    width: '100px'
  },
]
